import type { NotificationSeverity } from "@/lib/notification.api";
import { cn } from "@/lib/utils";
import { SEVERITY_CLASSES, SEVERITY_LABELS } from "../notification.constants";

export function NotificationSeverityBadge({ severity }: { severity: NotificationSeverity }) {
  return (
    <span
      className={cn(
        "inline-flex rounded border px-2 py-0.5 text-[10.5px] font-semibold",
        SEVERITY_CLASSES[severity],
      )}
    >
      {SEVERITY_LABELS[severity]}
    </span>
  );
}
